import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'
import { TimeUtils, BillingUtils } from '@front/volcanion/utils'

import moment from 'moment'

import FrameCallbacks from '../../callbacks'
import Callbacks from './callbacks'

const withContainer = Component => props => {
  const { openNotification } = hooks.useNotification()
  const setFormValues = hooks.useFormChange()
  const [{ record_id, isDurationRideMode, displayDownloadBillingButton, psp }] = hooks.useFormState()
  const [
    load_type,
    handling,
    base,
    driver_package_fee,
    prepaid,
    fees,
    duration_amount,
    option_amount,
    billing_status,
    service_amount,
    effective_handling_duration
  ] = hooks.useFieldValues([
    'load_type',
    'handling',
    'base',
    'driver_package_fee',
    'prepaid',
    'fees',
    'duration_amount',
    'option_amount',
    'billing_status',
    'service_amount',
    'assigned_transport.info.effective_handling_duration'
  ])

  const [order] = hooks.useModel('order', [record_id], {
    single: true, populate: [
      'specific_parameter',
      'quotation',
      'assigned_transport.info',
      'job.payment',
      'assigned_transport.payment'
    ]
  })
  const billing_color = hooks.useBillingStatusColorList()[billing_status]
  const [downloadInvoice] = hooks.useOrderInvoice(record_id)
  const handling_amount = hooks.useOrderHandlingAmount(record_id, effective_handling_duration)
  const [{ discount_percent: driver_discount_percent }] = hooks.useOrderDiscount(record_id, 'driver')
  const [{ discount_percent: customer_discount_percent }] = hooks.useOrderDiscount(record_id, 'customer')




  const passenger_fee = order?.quotation?.passenger_fee || 0
  const handling_slice = order?.quotation?.rate_parameter?.handling_slice || 0
  const stripeLink = !!psp ? `https://dashboard.stripe.com/payments/${psp}` : null
  const duration = TimeUtils.secondsToTime(moment(order?.assigned_transport?.info?.departureDropoffAt).diff(moment(order?.assigned_transport?.info?.departurePickedAt), 'seconds'), null, { hide_seconds: true })
  const formatted_effective_handling_duration = TimeUtils.secondsToTime(effective_handling_duration * 60, null, { hide_seconds: true })

  const updateBilledHandlingDuration = useCallback(Callbacks.updateBilledHandlingDurationHandler(setFormValues, handling_amount, handling_slice), [setFormValues, handling_amount, handling_slice])
  const handleInvoiceDownload = useCallback(FrameCallbacks.handleInvoiceDownloadHanlder(downloadInvoice, openNotification), [downloadInvoice, openNotification])

  const driver_total = BillingUtils.getPaymentDisplay(order?.job?.payment, true, 2, false)
  const customer_total = BillingUtils.getPaymentDisplay(order?.assigned_transport?.payment, true, 2, false)
  const driver_discount_amount = order?.job?.payment?.discount_amount
  const customer_discount_amount = order?.assigned_transport?.payment?.discount_amount
  const voucher_amount = order?.assigned_transport?.payment?.voucher_amount

  const mergedProps = {
    title: { billing_status, billing_color, stripeLink },
    row1: { formatted_effective_handling_duration, load_type, duration, updateBilledHandlingDuration, passenger_fee },
    row2: { handling, duration_amount, base, voucher_amount, isDurationRideMode },
    row3: { prepaid, fees, option_amount },
    row4: { driver_discount_amount, customer_discount_amount, driver_discount_percent, customer_discount_percent },
    row5: { driver_package_fee, service_amount },
    row6: { driver_total, customer_total, displayDownloadBillingButton, handleInvoiceDownload },
  }

  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
